module.exports = __webpack_public_path__ + "img/whats-next.8547cdaa.svg";